import { LOG_IN_SUCCESS, LOG_OUT, LOG_IN_ERROR } 	from '../actions/authActions'
import { push } 									from 'react-router-redux'
import { logOut, storeAccountData } 				from '../services/authServices'

const authMiddleWare = store => next => action => {
    switch (action.type) {
        case LOG_IN_SUCCESS:
            storeAccountData(action.data)
            break;
        case LOG_OUT:
        case LOG_IN_ERROR:
            logOut()
			storeAccountData(action.data)
            store.dispatch(push('/login'));
            break;
        default:
            break;
    }
    next(action);
}

export default authMiddleWare;



// WEBPACK FOOTER //
// ./src/middleware/authMiddleware.js